import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "./SalesCatalog.css";
import Nav from "../Nav/Nav";
import FirstSalesRow from "../FistSalesRow/FirstSalesRow";
import LogoLoader from "../Loading/Loading";
import Footer from "../Footer/Footer";
import buildingsData from "../../data/buildings.json";

const SalesCatalog = () => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const targetId = searchParams.get("targetId") || location.state?.targetId;

  const [building, setBuilding] = useState([]);

  useEffect(() => {
    if (buildingsData.length > 0) {
      const randomIndex = Math.floor(Math.random() * buildingsData.length);
      const selectedBuilding = buildingsData[randomIndex];

      setBuilding(selectedBuilding);
      console.log("Random building selected:", selectedBuilding);
    }
  }, []);

  useEffect(() => {
    if (!isLoading && targetId) {
      const timeout = setTimeout(() => {
        const el = document.getElementById(targetId);
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 1500);

      return () => clearTimeout(timeout);
    }
  }, [isLoading, targetId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2650);

    return () => clearTimeout(timer);
  }, []);

  const [isAlbanian, setIsAlbanian] = useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      localStorage.setItem("language", JSON.stringify(newLanguage));
      return newLanguage;
    });
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <LogoLoader />
      </div>
    );
  }

  return (
    <>
      <div className="salescatalog-container-up">
        <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />
        <div className="salescatalog-container">
          <img
            src={building.building_image_url}
            alt="salescatalog-photo"
            className="salescatalog-image"
          />
          <div className="overlay">
            <div className="vertical-line left"></div>
            <div className="vertical-line right"></div>
            <div className="hero-title">
              <h1 className="overlay-text">
                {isAlbanian ? (
                  <>
                    Investim i sigurt, <br />
                    <strong>
                      <span className="salescatalog-protest-font">
                        e ardhme
                      </span>
                      <img
                        src="/underlined2-1.png"
                        alt="Underline decoration"
                        className="underline-image"
                      />
                    </strong>{" "}
                    e qëndrueshme
                  </>
                ) : (
                  <>
                    Building that <br />
                    <strong>
                      <span className="salescatalog-protest-font">stands</span>
                      <img
                        src="/underlined2-1.png"
                        alt="Underline decoration"
                        className="underline-image"
                      />
                    </strong>{" "}
                    the test of time
                  </>
                )}
              </h1>
            </div>
            <div className="bottom-line"></div>
          </div>
        </div>
        <div id="firstSalesRow">
          <FirstSalesRow isAlbanian={isAlbanian} />
        </div>
      </div>
      <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default SalesCatalog;
